import { Accordion, Form } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingScreen } from "../../UiComponents/LoadingComponent"
import { useState } from "react";
import { getDateFormatted } from "../../utils/GridFormatter";
import { sbaAxios } from "../../utils/sbaAxios";
import { GetDynamicListInvestors, getContactAccess, getDyanmicContactListDetails, getProbability, getPipelineStatus, getGetEnumeration, insertOrUpdateStaticList, getDyanmicDateRange, insertOrUpdateDynamicList, deleteContactListApi, getStaticListContacts, getInvestorByPipeLine } from "../../../config/apiConfig";
import { SBADropDown, SBAMultiSelect } from "../../UiComponents/SBADropDown";
import { SBNotify } from "../../utils/sbNotify";
import { getAssetListByTerm } from "../../actions/CommonAction";
import { useRef } from "react";
import { DateRangePicker } from "rsuite";
import { Modal } from 'react-bootstrap';
import downloadSVG from '../../../Images/download.svg';
import moment from "moment";
import { getDyanmicContactList } from "../../actions/contactListAction";
import { exportToExcelUsingRef } from "../../utils/excelExporter";


const dynamicContactListMeta = {
    "ContactListId": null,
    "ContactListParamId": null,
    "ContactListName": '',
    "ContactListDescription": '',
    "IsActive": null,
    "ContactListTypeId": null,
    "SearchTypeId": null,
    "TypeOfList": null,
    "AssetId": null,
    "AssetName": '',
    "FromDate": null,
    "ToDate": null,
    "Param1": null,
    "Param1Value": null,
    "Param2": null,
    "Param2Value": null,
    "Param3": null,
    "Param3Value": null,
    "ModifiedBy": null,
    "ModifiedDate": null,
    "CreatedBy": null,
    "CreatedDate": null,
    "UserId": null,
    "ContactWebStatusTypeId": null,
    "IsOnlyMaster": null
};
export const DynamicList = () => {
    const dispatch = useDispatch();
    const dynamicListRef = useRef();
    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;
    const dynamicContactList = Gstate.Contacts.dynamicContactList;
    const isDynamicLoad = Gstate.Contacts.isStaticContactListLoading;
    
    const [selectedContactList, setSelectedContactList] = useState(dynamicContactListMeta);
    const [showModal, setShowModal] = useState(false);
    const [render,setRender]=useState(false);

    useEffect(()=>{
        dispatch(getDyanmicContactList());
    },[render])

    const ActionRenderer = (props) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
        return (
            <div className="actions-cell">
                {/* <i className={"fas fa-edit"} style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => { }}></i >  */}
                < i className={"fa fa-trash"} style={{ color: isEdit ? "#DF001B" : 'grey', margin: "0 8px", cursor: "pointer" }} onClick={() => { isEdit && setShowModal(true) }} ></i>
            </div >
        )
    }
    const columnDefs = [
        { headerName: "List Name", field: "ContactListName", tooltipField: 'ContactListName', filter: "agTextColumnFilter" },
        { headerName: "List Decription", field: "ContactListDecription", filter: "agTextColumnFilter" },
        { headerName: "Modified By Name", field: "ModifiedByName", filter: "agTextColumnFilter" },
        { headerName: "Modified Date", field: "ModifiedDate", valueFormatter: getDateFormatted, filter: "agTextColumnFilter" },
        { headerName: "Action", maxWidth: 100, field: "", cellRenderer: ActionRenderer }
    ];
    const defaultColDef = { sortable: true, filter: true, floatingFilter: true, flex: 1 ,resizable:true};
    const dynamicListRowClick = (e) => {
        const contactListID = e.data.ContactListId;
        getContactList(contactListID);
    };
    const getContactList = (contactListID) => {
        sbaAxios({ url: `${getDyanmicContactListDetails}${contactListID}`, method: 'get' }).then(response => {
            setSelectedContactList(response[0]);
        }).catch(error => {
            console.log(error);
        })
    };
    const addNewContact = () => {
        setSelectedContactList({ ...dynamicContactListMeta, SearchTypeId: 1, ContactListId: 0, ContactListSearchTypeId: 0, ContactListParamId: 0, "Param1": 1, "Param1Value": 0 });
    };
    const deleteContactList=()=>{
        sbaAxios({url:`${deleteContactListApi}${selectedContactList.ContactListId}/0`, method:'post'}).then(response=>{
            if(response==1)
            {
                SBNotify({Msg:'Selected Contact List has been Deleted',type:'success'});
            }
            setSelectedContactList(dynamicContactListMeta);
            setRender(!render);
        }).catch(error=>{
            console.log(error,'Error deleting Contact List')
        }
        )
        setShowModal(false);
    };
    return <>
        <div className="">
            <div className="accordionContainer">
                <Accordion defaultActiveKey="0" >
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Dynamic List</Accordion.Header>
                        <Accordion.Body>
                            <div className="d-flex">
                                <button className="ms-auto p-sm-btn" disabled={!isEditable} onClick={() => {isEditable && addNewContact() }}><i className="fa-plus fa-solid"></i>Add</button>
                            </div>
                            <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
                                {isDynamicLoad ? <><LoadingScreen /></> : <>
                                    <AgGridReact ref={dynamicListRef} rowSelection="single" columnDefs={columnDefs} defaultColDef={defaultColDef} rowData={dynamicContactList} onRowClicked={dynamicListRowClick} /></>}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
            <DynamicListEditSection contactList={selectedContactList}  setRender={setRender} render={render} getContactList={getContactList}/>
        </div>
        <Modal show={showModal}  >
      <Modal.Header closeButton onClick={()=>{setShowModal(false)}}>
        <Modal.Title>Do you want to delete the selected Conatct List?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>The selected Contact List will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button className="s-sm-btn mx-1" onClick={()=>{setShowModal(false)}}>Cancel</button>
        <button className='p-sm-btn mx-1' onClick={()=>{deleteContactList()}} >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
    </>
};
const DynamicListEditSection = ({ contactList ,setRender,render ,getContactList }) => {
    const [contactItem, setContactItem] = useState(contactList);
    const [searchTypeData, setSearchTypeData] = useState([]);
    const [investorLoading, setInvestorLoading] = useState(false);
    const [investorList, setInvestorList] = useState([]);
    const contactListAPI=useRef();
    const Gstate = useSelector(state => state);
    const isEditable = Gstate.authorizationData.isEditable;

    const searchTypeDisable = contactItem.ContactListId !== 0;
    const selectedSearchType = searchTypeData.find(item => item.EnumValue === contactItem.SearchTypeId);


    const getlistSearchTypeOptions = () => {
        sbaAxios({ url: `${getGetEnumeration}\ContactListSearchType`, method: 'get' }).then(response => {
            setSearchTypeData(response);
        }).catch(error => {
            console.log(error)
        })
    };
    useEffect(() => {
        getlistSearchTypeOptions();
    }, []);

    useEffect(() => {
        setContactItem(contactList);
    }, [contactList]);
    const updateContactItem = (value, field) => {
        setContactItem({ ...contactItem, [field]: value })
    }
    const updateContactMultipleItem = (toUpdateFields) => {

        setContactItem({ ...toUpdateFields, ...contactItem })
    }
    const textControlChange = (e, field) => {
        const updatedValue = e.target.value;
        updateContactItem(updatedValue, field);
    }
    const resetContact = () => {
        setContactItem(dynamicContactListMeta)
    };
    const updateContact = () => {
        if(contactItem.SearchTypeId===1)
        saveAssetSearch();
        if(contactItem.SearchTypeId===2)
        savePipeLine();
        if(contactItem.SearchTypeId===4)
        saveContactAccess();
    };
    const saveContactListItem=(saveData)=>
    {
        sbaAxios({ url: `${insertOrUpdateDynamicList}`, method: "post", data: saveData }).then(response => {
            getContactList(response);
            if(saveData.contactListId==0)
            SBNotify({ type: 'success', Msg: "Contact List has been Created Successfully" });
            if(saveData.contactListId>0)
            SBNotify({ type: 'success', Msg: "Contact List has been Updated Successfully" });  
            setRender(!render);
        }).catch(error => {
            console.log(error);
        })
    };
    const saveAssetSearch=()=>{
        const saveData={
            "contactListId": contactItem.ContactListId,
            "contactListParamId": contactItem.ContactListParamId,
            "contactListName": contactItem.ContactListName,
            "contactListDescription": contactItem.ContactListDescription,
            "searchTypeId": 1,
            "contactListTypeId": 1,
            "assetId": 0,
            "assetName": "",
            "fromDate": contactItem.FromDate,
            "toDate": contactItem.ToDate,
            "param1": contactItem.Param1,
            "param1Value": contactItem.Param1Value,
            "param2": contactItem.Param2,
            "param2Value": contactItem.Param2Value,
            "param3": contactItem.Param3,
            "param3Value": contactItem.Param3Value,
            "userId": 0,
            "contactWebStatusTypeId": contactItem.ContactWebStatusTypeId || 0,
            "isOnlyMaster": contactItem.IsOnlyMaster || false
        };
        if(saveData.param1==0)
        {
            saveData.param1Value=0
        }
        if(saveData.param1==0 && (!saveData.fromDate || !saveData.toDate ))
        {
            SBNotify({ type: 'error', Msg: "Please select the Date Range" })
        }
        else if (saveData.param1>0 && (saveData.param1Value==="" || saveData.param1Value===undefined || saveData.param1Value===null) )
        {
            SBNotify({ type: 'error', Msg: "Please select the Date Option SubType" })
        }
        else if (!saveData.param2)
        {
            SBNotify({ type: 'error', Msg: "Please Add Atleast One Asset" })
        }
        else
        {
            saveContactListItem(saveData);
        }
    };
    const savePipeLine=()=>{
        const saveData={
            "contactListId": contactItem.ContactListId,
            "contactListParamId": contactItem.ContactListParamId,
            "contactListName": contactItem.ContactListName,
            "contactListDescription": contactItem.ContactListDescription,
            "searchTypeId": 2,
            "contactListTypeId": 1,
            "assetId": 0,
            "assetName": "",
            "fromDate": contactItem.FromDate,
            "toDate": contactItem.ToDate,
            "param1": "Probability",
            "param1Value": contactItem.Param1Value,
            "param2": "AndOr",
            "param2Value": contactItem.Param2Value,
            "param3": "Status",
            "param3Value": contactItem.Param3Value,
            "userId": 0,
            "contactWebStatusTypeId": "",
            "isOnlyMaster": false
        };
        if(!saveData.param1Value)
        {
            SBNotify({ type: 'error', Msg: "Please select any Probability status" })
        }
        else if(!saveData.param2Value )
        {
            SBNotify({ type: 'error', Msg: "Please Select AND or OR" })
        }
        else if (!saveData.param3Value)
        {
            SBNotify({ type: 'error', Msg: "Please select any Pipeline status" })
        }
        else
        {
            saveContactListItem(saveData);
        }
    };
    const saveContactAccess=()=>{
        const saveData={
            "contactListId": contactItem.ContactListId,
            "contactListParamId": contactItem.ContactListParamId,
            "contactListName": contactItem.ContactListName,
            "contactListDescription": contactItem.ContactListDescription,
            "searchTypeId": 4,
            "contactListTypeId": 1,
            "assetId": 0,
            "assetName": "",
            "fromDate": contactItem.FromDate,
            "toDate": contactItem.ToDate,
            "param1": contactItem.Param1,
            "param1Value": contactItem.Param1Value,
            "param2": "",
            "param2Value": "",
            "param3": "",
            "param3Value": "",
            "userId": 0,
            "contactWebStatusTypeId": "",
            "isOnlyMaster": false
        };
        if (!saveData.param1Value)
        {
            SBNotify({ type: 'error', Msg: "Please Add Atleast One Access" })
        }
        else
        {
            saveContactListItem(saveData);
        }
       
    }
    const dynamicListDef = [
        { headerName: "Contact Name", field: "ContactName", tooltipField: 'ContactName' ,filter: "agTextColumnFilter" },
        { headerName: "Email Address", field: "BusinessEmail" ,filter: "agTextColumnFilter"},
        { headerName: "First Name", field: "FirstName" ,filter: "agTextColumnFilter"},
        { headerName: "Last Name", field: "LastName" ,filter: "agTextColumnFilter" },
        { headerName: "Salutation", field: "Salutation" ,filter: "agTextColumnFilter" }
    ];
    const defaultColDef={sortable: true, filter: true , floatingFilter: true, flex: 1,resizable:true};
    // asset list operation are defined here
    const searchTypeChange = (e) => {
        if (e.value) {
            if (e.value.EnumValue === 1)
                setContactItem({ ...contactItem, SearchTypeId: e.value.EnumValue, "Param1": 0, "Param1Value": 0 });
            if (e.value.EnumValue === 2)
                setContactItem({ ...contactItem, SearchTypeId: e.value.EnumValue, "Param1": "Probability", "Param1Value": null, "Param2": "AndOr", "Param2Value": 1, "Param3": "Status", "Param3Value": null });
            if (e.value.EnumValue === 4)
                setContactItem({ ...contactItem, SearchTypeId: e.value.EnumValue, "Param1": "Criteria", "Param1Value": null });
        };
    };
    return <> {contactItem.ContactListId !== null && <>
        <div className="p-3">
            <div className="row">
                <div className="col-md-4">
                    <label className="fw-medium">Search Type:</label>
                    <div>
                        <SBADropDown className="w-75" data={searchTypeData} textField={'EnumName'} valueField={'EnumValue'} value={selectedSearchType} disable={searchTypeDisable} onChange={(e) => { searchTypeChange(e) }} />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="fw-medium">List Name <span class="mandatory">*</span></label>
                    <Form.Control type="Text" className="w-75" value={contactItem.ContactListName} onChange={(e) => { textControlChange(e, 'ContactListName') }} />
                </div>
                <div className="col-md-4">
                    <label className="fw-medium">Description </label>
                    <Form.Control type="text" className="w-75" onChange={(e) => { textControlChange(e, 'ContactListDescription') }} value={contactItem.ContactListDescription} />
                </div>
            </div>
            <div className="d-flex mt-2">
                <button className="ms-auto s-sm-btn me-2" onClick={() => { resetContact() }}>Cancel</button>
                <button className="p-sm-btn" disabled={!isEditable} onClick={()=>{isEditable && updateContact()}}>{contactItem.ContactListId > 0 ? "Update" : "Save"}</button>
            </div>
        </div>
        <div className="detail p-3">
            <div className="row">
                {contactItem.SearchTypeId === 1 && <>
                    <AssetSearch setContactItem={setContactItem} contactItem={contactItem} setInvestorsList={setInvestorList} setInvestorLoading={setInvestorLoading}/>
                </>}
                {contactItem.SearchTypeId === 2 && <>
                    <PipelineSearch setContactItem={setContactItem} contactItem={contactItem} setInvestorsList={setInvestorList} setInvestorLoading={setInvestorLoading} />
                </>}
                {contactItem.SearchTypeId === 4 && <>
                    <ContactAccess setContactItem={setContactItem} contactItem={contactItem} setInvestorsList={setInvestorList} setInvestorLoading={setInvestorLoading}/>
                </>}
                <div className="col-md-6">
                    {investorLoading ? <><LoadingScreen /></> : <>
                        <div className="d-flex">
                            {(contactItem.SearchTypeId === 1 && contactItem.Param1==0) && <div>
                                <label className="fw-medium d-block">Date Range:</label><label className="fw-medium">{moment(contactItem?.FromDate).format('MM/DD/YYYY')}-{moment(contactItem?.ToDate).format('MM/DD/YYYY')}</label>
                            </div>}
                            <label className="fw-medium ms-auto">Matching Records: {investorList.length}</label>
                        </div>
                        <div className="d-flex">
                            <button className="ms-auto p-sm-btn" onClick={() => { exportToExcelUsingRef(contactListAPI, 'Lists') }}><img src={downloadSVG} alt="" />Export</button>
                        </div>
                        <div className="ag-theme-alpine" style={{ height: '46rem' }}>
                            <AgGridReact columnDefs={dynamicListDef} defaultColDef={defaultColDef} rowData={investorList} ref={contactListAPI} enableBrowserTooltips={true} ></AgGridReact>
                        </div></>
                    }
                </div>
            </div>
        </div>
    </>
    }
    </>
};
const AssetSearch = ({ contactItem, setContactItem,setInvestorsList,setInvestorLoading }) => {

    const dispatch = useDispatch();
    const AvailableAssetRef = useRef();
    const SelectedAssetRef = useRef();

    const Gstate = useSelector((state) => state);
    const isAssetListSearchedLoading = Gstate.common.isAssetListSearchedLoading;
    const assetListSearched = Gstate.common.assetListSearched;
    const [initialLoad,setInitialLoad]=useState(true);
    const [criteriaOptions, setCriteriaOptions] = useState([]);
    const [selectedCriteria,setSelectedCriteria]=useState([]);

    const [availableAsset, setAvailableAsset] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState([]);

    const fromDate = contactItem.FromDate ? new Date(contactItem.FromDate) : null;
    const toDate = contactItem.ToDate ? new Date(contactItem.ToDate) : null;

    const DateOptions = [
        { value: 1, text: 'YTD' },
        { value: 2, text: 'NYearBack' },
        { value: 3, text: 'CalendarYear' },
        { value: 4, text: 'NMonthsBack' }
    ];
    useEffect(()=>{
        getCriteriaOptions();
        getDefaultItems();
    },[contactItem.ContactListId]);
    useEffect(() => {
        if(initialLoad)
        {
            setInitialLoad(false);
        }
        else 
        setAvailableAsset(assetListSearched);
    }, [assetListSearched, isAssetListSearchedLoading]);
    const getDefaultItems=()=>{
        if (contactItem.ContactListId !== 0) {
            if(contactItem.Param2 && ((contactItem?.Param2).toString()).trim().length>0)
            {
                const AssetIDs = contactItem?.Param2?.split(',');
                const AssetNames = contactItem?.Param2Value?.split('~@@@~');
                if (AssetIDs.length > 0) {
                    const AssetByList = AssetIDs.map((item, index) => {
                        return {
                            "AssetType": null,
                            "AssetValue": null,
                            "AssetId": parseInt(item),
                            "AssetName": AssetNames[index],
                            "AccountTypeId": null
                        }
                    });
                    setSelectedAsset(AssetByList);
                }
            }
            if(!contactItem.Param1 && parseInt(contactItem?.Param1)!==0)
            {
                const dateOption=parseInt(contactItem.Param1) || 1;
                const dateValue=parseInt(contactItem.Param1Value) || 0;
    
                sbaAxios({ url: `${getDyanmicDateRange}${dateOption},${dateValue}`, method: 'get' }).then(response => {
                    setContactItem({ ...contactItem, "FromDate": response.FromDate, "ToDate": response.ToDate});
                    setTimeout(() => {
                        fetchInvestor();
                    }, 500); 
                }).catch(error => {
                    console.log(error);
                });
                
            }
            else {
                fetchInvestor();
            }
        }
        else {
            fetchFromToDate(1,0);
            setInvestorLoading(false);
            setSelectedAsset([]);
            setSelectedCriteria([]);
            setInvestorsList([]);
        }       
        
    };
    const getCriteriaOptions = () => {
        sbaAxios({ url: `${getContactAccess}`, method: 'get' }).then((response) => {
            setCriteriaOptions(response);
            if(contactItem.Param3)
            {
                const ItemId=contactItem.Param3.split(',').map(Number)
                const selectedOptions=[...response].filter(item => ItemId.includes(item.ContactAccessId))
                setSelectedCriteria([...selectedOptions]);
            }
        })
    };
    const getSearchedAsset = (e) => {
        const searchTerm = e.target.value;
        dispatch(getAssetListByTerm(searchTerm));
    };
    const availableAssetColDef = [
        { headerName: "Available Asset", field: "AssetName", tooltipField: 'AssetName', flex: 1 }
    ];
    const selectedAssetColDef = [
        { headerName: "Selected Asset", field: "AssetName", tooltipField: 'AssetName', flex: 1 }
    ];
    const YTDdata = [
        { value: 0, text: 'Today' },
        { value: 1, text: 'Month-1' },
        { value: 2, text: 'Month-2' },
        { value: 3, text: 'Month-3' },
        { value: 4, text: 'Month-4' },
    ];
    const CalendarYeardata = [
        { value: 0, text: 'Current Year' },
        { value: 1, text: 'Year-1' },
        { value: 2, text: 'Year-2' },
        { value: 3, text: 'Year-3' },
        { value: 4, text: 'Year-4' },
    ];
    const availableAssetRowClick = (e) => {
        const newItem = e.data;
        const exsitingItemIndex = selectedAsset.findIndex(item => item.AssetId === newItem.AssetId)
        if (exsitingItemIndex === -1) {
            const newList=[...selectedAsset, newItem];
            const assetIDs=newList.map(item=>item.AssetId).join(",");
            const assetNames=newList.map(item=>item.AssetName).join("~@@@~");
            setContactItem({...contactItem,"Param2":assetIDs,"Param2Value":assetNames})
            setSelectedAsset(newList);
        }
    };
    const selectAssetGridRowDoubleClick = (e) => {
        const itemToRemove = e.data;
        const updatedList=selectedAsset.filter(item => item.AssetId != itemToRemove.AssetId);
        const assetIDs=updatedList.map(item=>item.AssetId).join(",");
        const assetNames=updatedList.map(item=>item.AssetName).join("~@@@~");
        setContactItem({...contactItem,"Param2":assetIDs,"Param2Value":assetNames})
        setSelectedAsset(updatedList);
    };
    const addAsset = () => {
        const toAdd = AvailableAssetRef.current.api.getSelectedRows();
        if (toAdd.length > 0) {
            const itemIndex = selectedAsset.findIndex(item => item.AssetId == toAdd[0].AssetId)
            if (itemIndex == -1) {
                const newList=[...selectedAsset, toAdd[0]];
                const assetIDs=newList.map(item=>item.AssetId).join(",");
                const assetNames=newList.map(item=>item.AssetName).join("~@@@~");
                setContactItem({...contactItem,"Param2":assetIDs,"Param2Value":assetNames})
                setSelectedAsset(newList);
            }
        }
    };
    const removeAsset = () => {
        const toRemove = SelectedAssetRef.current.api.getSelectedRows();
        if (toRemove.length > 0) {
            const updatedList = selectedAsset.filter(item =>
                item.AssetId !== toRemove[0].AssetId
            );
            const assetIDs = updatedList.map(item => item.AssetId).join(",");
            const assetNames = updatedList.map(item => item.AssetName).join("~@@@~");
            setContactItem({ ...contactItem, "Param2": assetIDs, "Param2Value": assetNames })
            setSelectedAsset(updatedList);
        }
    };
    const dateRangeChanged = (e) => {
        
        if (e[0] && e[1]) {
            setContactItem({ ...contactItem, "FromDate": e[0].toISOString(), "ToDate": e[1].toISOString() });
        }
    };
    const updateContactItem = (value, field) => {
        setContactItem({ ...contactItem, [field]: value })
    };
    const updateContactMultipleItem = (toUpdateFields) => {
        setContactItem({ ...contactItem, ...toUpdateFields })
    };
    const dateOptionChange = (e) => {
        if (e.value) {
            updateContactMultipleItem({ 'Param1': e.value.value , 'Param1Value': null })
        }
    };
    const dateRangeDDChange = (e,type) => {
        if (e.value) {
            const value = parseInt(e.value.value);
             setDyanmicTextRange(e,type,value)
        }
    };
    const dateRangeTextChange = async(e,type) => {
        if (e.target.value) {
            try {
                const value = parseInt(e.target.value);
                setDyanmicTextRange(e, type, value);
            }
            catch {
            }
        }
        else {
            updateContactItem(null,"Param1Value");
        }
    };
    const criteriaChng = (e) => {
        const newCriteria=[...e.value]
        const newCriteriaIds=newCriteria.map(item => item.ContactAccessId).join(',');
        const newCriteriaNames=newCriteria.map(item => item.ContactAccessName).join(',');
        setContactItem({...contactItem,Param3Value:newCriteriaNames,Param3:newCriteriaIds});
        setSelectedCriteria(newCriteria);
    };
    const isMasterChange=()=>{
        const isMaster=contactItem.IsOnlyMaster;
        setContactItem({...contactItem,IsOnlyMaster:!isMaster});
    }
    const webStatusChange=()=>{
        const webStatus=parseInt(contactItem.ContactWebStatusTypeId);
        setContactItem({...contactItem,ContactWebStatusTypeId:webStatus===1?0:1});
    };
    const setDyanmicTextRange = (e, type, value) => {
        let dateOption = null;
        let dateValue = null;
        switch (type) {
            case "YTD":
                dateOption = 1;
                dateValue = e.value.value;
                break;
            case "CalendarYear":
                dateOption = 3;
                dateValue = e.value.value;
                break;
            case "NYear":
                dateOption = 2;
                dateValue = parseInt(e.target.value);
                break;
            case "NMonth":
                dateOption = 4;
                dateValue = parseInt(e.target.value);
                break;
            default:
                break;
        }
        sbaAxios({ url: `${getDyanmicDateRange}${dateOption},${dateValue}`, method: 'get' }).then(response => {
            setContactItem({ ...contactItem, "FromDate": response.FromDate, "ToDate": response.ToDate, "Param1Value": value });
        }).catch(error => {
            console.log(error);
        });

    };
    const fetchInvestor = () => {
                setInvestorLoading(true);
                const requestData = {
                    "assetIdList": contactItem.Param2,
                    "fromDate": contactItem.FromDate || new Date().toISOString(),
                    "toDate": contactItem.ToDate || new Date().toISOString(),
                    "contactAccessIdList": contactItem.Param3,
                    "contactListSearchTypeId": 1,
                    "contactWebStatusId": contactItem.ContactWebStatusTypeId,
                    "isOnlyMaster": contactItem.IsOnlyMaster || false,
                    "showDoNotEmail": false
                }
                sbaAxios({ url: `${GetDynamicListInvestors}`, method: 'post', data: requestData }).then((response) => {
                    setInvestorsList(response);
                    setInvestorLoading(false);
                }).catch(error => {
                    console.log(error);
                });
    };
    const fetchFromToDate=(dateOption,dateValue)=>{
        sbaAxios({ url: `${getDyanmicDateRange}${dateOption},${dateValue}`, method: 'get' }).then(response => {
            setContactItem({ ...contactItem, "FromDate": response.FromDate, "ToDate": response.ToDate});
        }).catch(error => {
            console.log(error);
        });
    };
    const dynaimcRadioClick=()=>{
        updateContactMultipleItem({ 'Param1': 1, 'Param1Value': 0 });
        // fetchFromToDate(1,0); 
    }
    return <div className="col-md-6">
        <label className="fw-medium">Asset Search</label>
        <Form.Control type="Text" className="w-75" placeholder="Enter Asset Name" onKeyUp={getSearchedAsset} />
        <div className="gridcontent d-flex flex-row">
            <div className='gridDiv' style={{ minWidth: '44%' }}>
                <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                    {isAssetListSearchedLoading ? <><LoadingScreen /></> :
                        <>
                            <AgGridReact
                                columnDefs={availableAssetColDef}
                                rowData={availableAsset}
                                onRowDoubleClicked={availableAssetRowClick}
                                rowSelection={'single'}
                                ref={AvailableAssetRef}
                                enableBrowserTooltips={true}
                                defaultColDef={{resizable:true}}
                            >
                            </AgGridReact>
                        </>

                    }
                </div>
            </div>
            <div className='d-flex flex-column justify-content-center px-3'>
                <button className='p-sm-btn my-1' onClick={addAsset}>
                    <i class="fa-solid fa-arrow-right"></i>
                </button>
                <button className='p-sm-btn my-1' onClick={removeAsset}>
                    <i class="fa-solid fa-arrow-left" ></i>
                </button>
            </div>
            <div className='gridDiv' style={{ minWidth: '45%' }}>
                <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                    <AgGridReact
                        columnDefs={selectedAssetColDef}
                        rowData={selectedAsset}
                        onRowDoubleClicked={selectAssetGridRowDoubleClick}
                        rowSelection={'single'}
                        ref={SelectedAssetRef}
                        enableBrowserTooltips={true}
                        defaultColDef={{resizable:true}}
                    >
                    </AgGridReact>
                </div>
            </div>
        </div>
        <div className="mt-2">
            <div className='my-3'>
                <label className="fw-medium">List Type :</label>
                <input type="radio" className="mx-2" name="listType" checked={parseInt(contactItem.Param1) === 0} onChange={(e) => { updateContactItem(0, 'Param1') }} disabled value={0} />
                <label className="fw-medium">Static</label>
                <input type="radio" className="mx-2" name="listType" checked={parseInt(contactItem.Param1) !== 0} onChange={(e) => { dynaimcRadioClick() }} value={1} />
                <label className="fw-medium">Dynamic</label>
            </div>
            {parseInt(contactItem.Param1) === 0 && <>
                <label className="fw-medium">Select Range</label>
                <DateRangePicker
                    className="SbaDateRage text-dark w-75"
                    placeholder="Please Select"
                    value={[fromDate, toDate]}
                    format="MM/dd/yyyy"
                    block
                    character=" - "
                    placement="topStart"
                    onChange={dateRangeChanged}
                />
            </>}
            {parseInt(contactItem.Param1) > 0 && <>
                <div>
                    <label className="fw-medium w-75 mt-2">Date Options</label>
                    <div className="mt-2">
                        <SBADropDown className="w-75" data={DateOptions} textField='text' valueField='value' value={DateOptions[parseInt(contactItem.Param1) - 1]} onChange={(e) => { dateOptionChange(e)}} />
                    </div>
                    {parseInt(contactItem.Param1) === 1 && <div className="mt-2">
                        <>
                            <label className="fw-medium w-75 mt-2">End Date</label>
                            <SBADropDown data={YTDdata} textField='text' valueField='value' value={YTDdata[parseInt(contactItem.Param1Value)]} className='w-75' onChange={(e) => { dateRangeDDChange(e,"YTD") }} />
                        </>
                    </div>}
                    {parseInt(contactItem.Param1) === 2 && <div className="mt-2">
                        <>
                            <label className="fw-medium w-75 mt-2">Year</label>
                            <Form.Control type="number" className='w-75' value={parseInt(contactItem.Param1Value)} onChange={(e) => { dateRangeTextChange(e,"NYear")}} />
                        </>
                    </div>}
                    {parseInt(contactItem.Param1) === 3 && <div className="mt-2">
                        <>
                            <label className="fw-medium w-75 mt-2">Year</label>
                            <SBADropDown data={CalendarYeardata} value={CalendarYeardata[parseInt(contactItem.Param1Value)]} textField='text' valueField='value' className='w-75' onChange={(e) => { dateRangeDDChange(e,"CalendarYear") }} />
                        </>
                    </div>}
                    {parseInt(contactItem.Param1) === 4 && <div className="mt-2">
                        <>
                            <label className="fw-medium w-75 mt-2">Month</label>
                            <Form.Control type="number" className='w-75' value={parseInt(contactItem.Param1Value)} onChange={(e) => { dateRangeTextChange(e,"NMonth") }} />
                        </>
                    </div>}
                </div>
            </>}
            <div className="detail p-3 mt-2">
                        <>
                            <label className="fw-medium mt-2">Criteria</label>
                            <div className="mt-2">
                                <SBAMultiSelect data={criteriaOptions} textField='ContactAccessName' valueField='ContactAccessId' value={selectedCriteria} onChange={criteriaChng} />
                            </div>
                            <label className="fw-medium mt-2" >Only active Web Users</label> <input type="checkbox" onChange={() => {webStatusChange() }} checked={contactItem.ContactWebStatusTypeId == 1 ? true : false} />
                            <label className="fw-medium mx-4">Only RM's'</label> <input type="checkbox" onChange={() => { isMasterChange() }} checked={contactItem.IsOnlyMaster} />
                        </>
                    </div>
                    <div className="d-flex mt-2">
                        <button className=" ms-auto me-2 p-sm-btn" onClick={() => {fetchInvestor()} }>Fetch</button>
                    </div>
        </div>
    </div>
};
const PipelineSearch = ({ contactItem, setContactItem,setInvestorsList,setInvestorLoading }) => {

    const [probability, setProbability] = useState([]);
    const [pipelineStatus, setPipelineStatus] = useState([]);
    const [selectedProbability, setSelectedProbability] = useState();
    const [selectedPipeline, setSelectedPipeline] = useState();


    useEffect(() => {
        getProbabilityOptions();
        getPipelineStatusOptions();
        fetchInvestor();
    }, [contactItem.ContactListId]);
    const updateContactItem = (value, field) => {
        
        setContactItem({ ...contactItem, [field]: value })
    };
    const updateContactMultipleItem = (toUpdateFields) => {
        setContactItem({ ...toUpdateFields, ...contactItem })
    };
    const getProbabilityOptions = () => {
        sbaAxios({ url: `${getProbability}`, method: 'get' }).then((response) => {
            setProbability(response);
            setSelectedProbability(response.find(item => item.PipelineProbabilityId === parseInt(contactItem.Param1Value)));
        })
    };
    const getPipelineStatusOptions = () => {
        sbaAxios({ url: `${getPipelineStatus}`, method: 'get' }).then((response) => {
            setPipelineStatus(response);
            setSelectedPipeline(response.find(item => item.PipelineStatusId === parseInt(contactItem.Param3Value)));
        })
    };
    const probabilityChange = (e) => {
        if (e.value) {
            const newValue = e.value.PipelineProbabilityId;
            setSelectedProbability(e.value);
            updateContactItem(newValue, "Param1Value");
        }

    };
    const pipeLineChange = (e) => {
        if (e.value) {
            const newValue = e.value.PipelineStatusId;
            setSelectedPipeline(e.value);
            updateContactItem(newValue, "Param3Value");
        }

    };

    const fetchInvestor = () => {
        setInvestorLoading(true);
        const ProbabilityId=contactItem.Param1Value;
        const StatusId=contactItem.Param3Value;
        const AndOrValue=contactItem.Param2Value;
        sbaAxios({url:`${getInvestorByPipeLine}${ProbabilityId},${StatusId},${AndOrValue}`}).then(
            response=>{
                setInvestorsList(response);
                setInvestorLoading(false);
            }
        ).catch(error=>{
            console.log(error,'error fetching the pipeline Investor')
            setInvestorLoading(false)
            setInvestorsList([]);
        })
    }

    return <><div className="col-md-6">
        <label className="fw-medium">Probability:</label>
        <div>
            <SBADropDown data={probability} textField="PipelineProbilityName" valueField="PipelineProbabilityId" value={selectedProbability} onChange={(e) => { probabilityChange(e) }} />
        </div>
        <div className="my-2 d-flex">
            <div className="my-2 mx-3">
                <input type="radio" name="pipelineType" checked={parseInt(contactItem.Param2Value) === 1} onChange={()=>{updateContactItem(1, "Param2Value")}} />
                <label className="fw-medium mx-1">And</label>
            </div>
            <div className="my-2 mx-3">
                <input type="radio" name="pipelineType" checked={parseInt(contactItem.Param2Value) === 0}onChange={()=>{updateContactItem(0, "Param2Value")}} />
                <label className="fw-medium mx-1">Or</label>
            </div>
        </div>
        <label className="fw-medium">Status:</label>
        <div>
            <SBADropDown data={pipelineStatus} textField="PipelineStatusName" valueField="PipelineStatusId" value={selectedPipeline} onChange={(e) => { pipeLineChange(e) }} />
        </div>
        <div className="d-flex mt-2">
            {/* <button className="s-sm-btn ms-auto me-2" onClick={()=>{}}>Cancel</button> */}
            <button className=" ms-auto me-2 p-sm-btn" onClick={() => { fetchInvestor()}}>Fetch</button>
        </div>
    </div></>
};
const ContactAccess = ({ contactItem, setContactItem ,setInvestorsList,setInvestorLoading}) => {
    
    const [criteriaOptions, setCriteriaOptions] = useState([]);
    const [selectedContactListCriteria, setSelectedContactListCriteria] = useState([]);

    const selectedCriteriaRef = useRef();
    const availableCriteriaRef = useRef();

    useEffect(() => {
        getCriteriaOptions();
        fetchInvestor();
    }, [contactItem.ContactListId]);
    const SelectedCriteriaColDef = [
        { headerName: "Selected Access", field: "ContactAccessName", tooltipField: 'ContactAccessName', flex: 1 }
    ];

    const AvailableCriteriaColDef = [
        { headerName: "Available Access", field: "ContactAccessName", tooltipField: 'ContactAccessName', flex: 1 }
    ];

    const getCriteriaOptions = () => {
        sbaAxios({ url: `${getContactAccess}`, method: 'get' }).then((response) => {
            setCriteriaOptions(response);
            const ItemId=contactItem.Param1Value.split(',').map(Number)
            const selectedOptions=[...response].filter(item => ItemId.includes(item.ContactAccessId))
            setSelectedContactListCriteria([...selectedOptions]);
        })
    };
    const availableCriteriaDoubleCLK = (e) => {
        
        const newCriteria = e.data;
        const exsitingItemIndex = selectedContactListCriteria.findIndex(item => item.ContactAccessId === newCriteria.ContactAccessId)
        if (exsitingItemIndex === -1) {
            const newList = [...selectedContactListCriteria, newCriteria];
            const newValue = newList.map(item => item.ContactAccessId).join(',')
            setContactItem({ ...contactItem, Param1Value: newValue });
            setSelectedContactListCriteria(newList);
        }
    };
    const removeCriteria = (e) => {
        const toRemove = selectedCriteriaRef.current.api.getSelectedRows();
        if (toRemove.length > 0) {
            const newList = selectedContactListCriteria.filter(item => item.ContactAccessId !== toRemove[0].ContactAccessId);
            const newValue=newList.map(item => item.ContactAccessId).join(',')
            setContactItem({...contactItem,Param1Value:newValue});
            setSelectedContactListCriteria([...newList]);
        }
    };
    const addCriteria = () => {
        const toAdd = availableCriteriaRef.current.api.getSelectedRows();
        if (toAdd.length > 0) {
            const itemIndex = selectedContactListCriteria.findIndex(item => item.ContactAccessId == toAdd[0].ContactAccessId)
            if (itemIndex === -1) {
                const newList=[...selectedContactListCriteria, toAdd[0]];
                const newValue=newList.map(item => item.ContactAccessId).join(',')
                setContactItem({...contactItem,Param1Value:newValue});
                setSelectedContactListCriteria([...selectedContactListCriteria, toAdd[0]])
            }
        }
    };
   
    const selectedCriteriaDoubleCLK = (e) => {
        const toRemove = e.data;
        const newList = selectedContactListCriteria.filter(item => item.ContactAccessId !== toRemove.ContactAccessId)
        const newValue = newList.map(item => item.ContactAccessId).join(',')
        setContactItem({ ...contactItem, Param1Value: newValue });
        setSelectedContactListCriteria([...newList]);
    };
    const fetchInvestor=()=>{
        setInvestorLoading(true);
        const requestData={
            "assetIdList":"",
            "fromDate": contactItem.FromDate || new Date().toISOString(),
            "toDate": contactItem.ToDate || new Date().toISOString(),
            "contactAccessIdList": contactItem.Param1Value,
            "contactListSearchTypeId": 4,
            "contactWebStatusId":  0,
            "isOnlyMaster": false,
            "showDoNotEmail": false
        }
        sbaAxios({ url: `${GetDynamicListInvestors}`, method: 'post', data: requestData }).then((response) => {
            setInvestorsList(response);
            setInvestorLoading(false);

        }).catch(error => {
            console.log(error);
        })
    }
    return <>
        <div className="col-md-6">
            <div className="gridcontent d-flex flex-row">
                <div className='gridDiv' style={{ minWidth: '44%' }}>
                    <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                        <AgGridReact
                            columnDefs={AvailableCriteriaColDef}
                            rowData={criteriaOptions}
                            onRowDoubleClicked={availableCriteriaDoubleCLK}
                            rowSelection={'single'}
                            ref={availableCriteriaRef}
                            enableBrowserTooltips={true}
                            defaultColDef={{resizable:true}}
                        >
                        </AgGridReact>
                    </div>
                </div>
                <div className='d-flex flex-column justify-content-center px-3'>
                    <button className='p-sm-btn my-1' onClick={addCriteria}>
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                    <button className='p-sm-btn my-1' onClick={removeCriteria}>
                        <i class="fa-solid fa-arrow-left" ></i>
                    </button>
                </div>
                <div className='gridDiv' style={{ minWidth: '45%' }}>
                    <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                        <AgGridReact
                            columnDefs={SelectedCriteriaColDef}
                            rowData={selectedContactListCriteria}
                            onRowDoubleClicked={selectedCriteriaDoubleCLK}
                            rowSelection={'single'}
                            ref={selectedCriteriaRef}
                            enableBrowserTooltips={true}
                            defaultColDef={{resizable:true}}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </div>
            <div className="d-flex mt-2">
                {/* <button className="s-sm-btn ms-auto me-2" onClick={()=>{}}>Cancel</button> */}
                <button className=" ms-auto me-2 p-sm-btn" onClick={() => { fetchInvestor()}}>Fetch</button>
            </div>
        </div>
    </>
};
